import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ProductCard from "@components/V2/Cards/Product"
import { Color } from "@constants/V2/color"
import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryBlokContentCard = ({
  blok,
  mobileGridOrder,
  siblingCount,
}: Storyblok.BlokProps<Storyblok.ContentCard>) => {
  return (
    <ProductCard
      mobileGridOrder={mobileGridOrder}
      superScript={blok.superScript}
      productName={blok.heading}
      shortDescription={blok.description}
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      priceAdornmentText="R"
      priceValue={blok.price}
      learnMoreButtonUrl={storyblokLinkToYocoLink(blok.learnMoreUrl)}
      backgroundColor={blok.backgroundColor || Color.White}
      siblingCount={siblingCount}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryBlokContentCard
